var $carousel;
var flkty;
var $videoCarouselNav = $('.video-carousel__nav');

jQuery(document).ready(function ($) {
  function updateVisibleSlides() {
    $('.carousel-item').removeClass('visible');
    $('.carousel-item').attr('aria-hidden', true);

    $('.carousel-item.is-selected').addClass('visible');
    $('.carousel-item.is-selected').attr('aria-hidden', false);

    if ($(window).width() > 992) {
      var secondSlide = $('.carousel-item.is-selected').next();
      if ($(secondSlide).length < 1) {
        secondSlide = $('.carousel-item').first();
      }
      $(secondSlide).addClass('visible');
      $(secondSlide).attr('aria-hidden', false);

      var thirdSlide = $(secondSlide).next();
      if ($(thirdSlide).length < 1) {
        thirdSlide = $('.carousel-item').first();
      }
      $(thirdSlide).addClass('visible');
      $(thirdSlide).attr('aria-hidden', false);
    } else if ($(window).width() <= 992 && $(window).width() > 768) {
      secondSlide = $('.carousel-item.is-selected').next();
      if ($(secondSlide).length < 1) {
        secondSlide = $('.carousel-item').first();
      }
      $(secondSlide).addClass('visible');
      $(secondSlide).attr('aria-hidden', false);
    }
  }

  function resizeFn() {

    updateVisibleSlides();


    window.console.log($(window).width());
    if ($(window).width() <= 768) {
      flkty.options.draggable = true;
      flkty.updateDraggable();
      $videoCarouselNav.show();
    }

    if ($(window).width() <= 992) {
      if (flkty.cells.length <= 2) {
        $videoCarouselNav.hide();
      } else {
        $videoCarouselNav.show();
        flkty.options.draggable = true;
        flkty.updateDraggable();
      }
    }

    if ($(window).width() > 992 && flkty.cells.length <= 3) {
      flkty.options.draggable = false;
      flkty.updateDraggable();
      $videoCarouselNav.hide();
    }

    flkty.resize();
  }

  if ($('.carousel-section').length > 0) {
    $carousel = $('.video-carousel').flickity({
      cellAlign: 'left',
      wrapAround: true,
      prevNextButtons: false,
      pageDots: false
    });

    flkty = $carousel.data('flickity');

    var $cellButtonGroup = $('.video-carousel__dots');
    var $cellButtons = $cellButtonGroup.find('.dot');

    resizeFn();
    $(window).resize(resizeFn);

    // update selected cellButtons
    $carousel.on('select.flickity', function () {
      $cellButtons.filter('.is-selected')
        .removeClass('is-selected');
      $cellButtons.eq(flkty.selectedIndex)
        .addClass('is-selected');
    });

    $carousel.on('dragStart.flickity', function () {
      $('.carousel-item').addClass('visible');
    });

    $carousel.on('dragEnd.flickity', function () {
      updateVisibleSlides();
    });

    // select cell on button click
    $cellButtonGroup.on('click', '.dot', function () {
      var index = $(this).index();
      $carousel.flickity('select', index);
      updateVisibleSlides();
    });
    // previous
    $('.button--previous').on('click', function () {
      $carousel.flickity('previous');
      updateVisibleSlides();
    });
    // next
    $('.button--next').on('click', function () {
      $carousel.flickity('next');
      updateVisibleSlides();
    });

  }
});
